import axios from 'axios';
import scrollBack from './../utils/scrollBack';

document.addEventListener("DOMContentLoaded", () => {
  let articleButtons = document.querySelectorAll('[data-post-id]');

  if (articleButtons) {
    let overlay = document.createElement('div');
    overlay.classList.add('overlay');

    let overlayInner = document.createElement('div');
    overlayInner.classList.add('overlay__inner');
    overlay.appendChild(overlayInner);
    document.body.appendChild(overlay);

    articleButtons.forEach((articleButton) => {
      articleButton.addEventListener('click', (event) => {
        overlay.classList.add('overlay--active');
        document.body.classList.add('overlay-is-active');

        let data = {
          action: 'get_article',
          id: articleButton.dataset.postId,
          _ajax_nonce: schakenboschAjax.nonce,
        };

        let overlayContainer = document.querySelector('.overlay .overlay__inner');
        overlay.classList.add('overlay--loading');
        overlayContainer.innerHTML = '<div class="loader"></div>';

        axios.get(schakenboschAjax.url, { params: data })
        .then( function(response) {
          if (response && response.data) {
            if (overlay) {
              overlay.classList.remove('overlay--loading');
              overlayContainer.innerHTML = response.data;

              let href = window.location.href;
              history.pushState({ ajax : true, origin : href }, null, articleButton.getAttribute('href'));

              let overlayClose = overlay.querySelector('.overlay__close');
              overlayClose.addEventListener('click', () => {
                overlay.classList.remove('overlay--active');
                document.body.classList.remove('overlay-is-active');

                history.pushState({ ajax : true, origin : href }, null, href);
              });

              let footer = document.querySelector(".overlay footer");
              if (footer) {
                scrollBack(footer, overlay);
              }
            }
          }
        });

        event.preventDefault();
      });
    });
  }
});
